const actions = {
  SET_HR_USER_ID: 'SET_HR_USER_ID',
  setUserId: (providerId, userId) => {
    return {
      type: actions.SET_HR_USER_ID,
      payload: {
        providerId: providerId,
        userId
      }
    }
  },
  PUSH_HR_USER_HEADER: 'PUSH_HR_USER_HEADER',
  POP_HR_USER_HEADER: 'POP_HR_USER_HEADER',
  pushHeader: (mode) => {
    return {
      type: actions.PUSH_HR_USER_HEADER,
      payload: {
        show: mode
      }
    }
  },
  popHeader: () => {
    return {
      type: actions.POP_HR_USER_HEADER
    }
  }
}
export default actions
